import { useEffect, useState } from "react";

import { fetchLocaleInfo } from "../api/fetchLocaleInfo";

interface IServerTime {
  serverTime: number;
  receivedAt: number;
}

let serverTimePromise: Promise<IServerTime | undefined> | null = null;

const getServerTime = (force = false) => {
  if (!serverTimePromise || force) {
    serverTimePromise = fetchLocaleInfo().then((localeInfo) => {
      if (!localeInfo) {
        serverTimePromise = null;
        return undefined;
      }

      return { serverTime: new Date(localeInfo.server_time).getTime(), receivedAt: performance.now() };
    });
  }

  return serverTimePromise;
};

export default function useServerTime(): {
  serverTime: Date;
  isLoading: boolean;
  refetch: () => Promise<void>;
} {
  const [serverTime, setServerTime] = useState(new Date());
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    void updateServerTime();
  }, []);

  const updateServerTime = async (force = false) => {
    const result = await getServerTime(force);

    setServerTime(new Date(result ? result.serverTime + (performance.now() - result.receivedAt) : Date.now()));
    setIsLoading(false);
  };

  return { serverTime, isLoading, refetch: () => updateServerTime(true) };
}
